<template>
    <label
        class="dk-configuration-trim-card tw-group tw-flex tw-flex-col tw-gap-1 lg:tw-gap-2 tw-p-4 lg:tw-p-6 tw-border tw-border-solid tw-rounded"
        :class="{
            'tw-border-border-color tw-duration-300 hover:lg:tw-border-slate-500 hover:lg:tw-bg-secondary-light tw-cursor-pointer': !isSelected,
            'tw-border-brand-primary tw-bg-primary-light': isSelected,
        }"
        :for="`radio-trim-${id}`"
        @click.stop="onClick"
    >
        <span class="dk-configuration-trim-card__wrapper tw-flex tw-items-center">
            <input
                :id="`radio-trim-${id}`"
                class="dk-configuration-trim-card__radio checked:!tw-border-brand-primary checked:before:!tw-bg-brand-primary"
                type="radio"
                value="value"
                :checked="isSelected"
            >
            <h3 class="dk-configuration-trim-card__name tw-font-semibold tw-text-base lg:tw-text-lg tw-leading-base">
                {{ name }}
            </h3>
        </span>
        <div class="dk-configuration-trim-card___pricing">
            <span
                class="dk-configuration-trim-card__price-from tw-mr-[2px] tw-text-sm lg:tw-text-base tw-leading-sm lg:tw-leading-base"
            >
                {{ $t('model.version.price-from') }}
            </span>
            <span
                class="dk-configuration-trim-card__price tw-text-sm lg:tw-text-base tw-leading-sm lg:tw-leading-base tw-font-semibold"
            >
                {{ priceFrom }}
            </span>
        </div>
    </label>
</template>

<script>
export default {
    name: 'DkConfigurationTrimCard',
    props: {
        /**
         * The version ID
         */
        id: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            required: true,
        },
        priceFrom: {
            type: String,
            required: true,
        },
        isSelected: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick($event) {
            /**
             * Fired when clicked on the version item
             *
             * @event click
             * @type {object}
             * @property {object} $event - Click event
             * @property {object} id - Item versionId
             */
            this.$emit('click', {
                $event,
                trimId: this.id,
            });
        },
    },
};
</script>
